import { err, ok } from 'neverthrow'
import { evaluatorErrorWithNode } from '../../scriptevaluator/EvaluatorError'
import { functionNodeTypes, HelperFunction } from '../FunctionTypes'

export const RoundFunction: HelperFunction = {
	tokenName: 'ROUND',
	nodeType: functionNodeTypes.Round,
	evaluate(node, evaluateExpr) {
		const args = node.arguments
		if (args.length < 1 || args.length > 2) {
			return err(evaluatorErrorWithNode('ROUND function expects one or two arguments', node))
		}
		const valueResult = evaluateExpr(args[0])
		if (valueResult.isErr()) return err(valueResult.error)
		const value = Number(valueResult.value)
		if (args[1]) {
			const precisionResult = evaluateExpr(args[1])
			if (precisionResult.isErr()) return err(precisionResult.error)
			return ok(Number(value.toFixed(Number(precisionResult.value))))
		}
		return ok(Math.round(value))
	}
}
